module.exports = "<message></message> <div class=\"c-dashboard--arrivals c-arrivals\"> <header class=c-page-head> <div class=c-dashboard__welcome> <h2>Guest Arrivals</h2> </div> </header> <main> <div class=row> <div class=\"small-12 columns\"> <arrival-list arrivals=$ctrl.today date=today></arrival-list> <arrival-list arrivals=$ctrl.tomorrow date=tomorrow></arrival-list> </div> </div> </main> </div> ";


//////////////////
// WEBPACK FOOTER
// ./frontend/admin/app/modules/guests/views/arrival.dashboard.html
// module id = 981
// module chunks = 0